/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useRef } from "react";

import { useLocation } from "react-router";

import useTableFunctions from "@/components/Table/hooks/useTableFunctions";
import TableCell from "@mui/material/TableCell";

import { colors } from "@dotnet/telematics-design-system";

import {
  COLUMN_NAMES,
  COLUMN_RESOURCES,
  ROUTES,
  tableColumnRightDropShadow
} from "../../../../../shared";
import { useIsXOverflow } from "../../../../../shared/hooks/useIsXOverflow";
import { LongTextTooltip } from "../../../../Tooltip/LongTextTooltip";

interface TableColumnProps {
  data: any;
  name: COLUMN_NAMES;
  resource: COLUMN_RESOURCES;
  isCheckable: boolean;
  isSticky?: boolean;
  scrollHorizontal?: boolean;
  secondCellValue?: COLUMN_RESOURCES;
  onToggleChange?: (rowData: any) => Promise<void>;
}

const TableColumn = ({
  data,
  name,
  resource,
  isCheckable,
  isSticky,
  scrollHorizontal,
  secondCellValue,
  onToggleChange
}: TableColumnProps) => {
  const location = useLocation();

  const { renderValue } = useTableFunctions(onToggleChange);

  const ref = useRef(null);
  const isOverflowing = useIsXOverflow(ref);

  const companiesPage = location.pathname === ROUTES.Companies;

  const boxShadowBottom = `inset 0px -1px 0px ${colors.gray200}`;

  const paddingLeft = () => {
    if (isSticky) {
      return "60px";
    }

    return "unset";
  };

  return (
    <LongTextTooltip
      title={renderValue(name, resource, data)}
      open={isOverflowing}
      customMaxWidth="344px"
    >
      <TableCell
        ref={ref}
        css={css([
          {
            position: isSticky ? "sticky" : "unset",
            left: isCheckable ? paddingLeft() : "0",
            boxShadow: boxShadowBottom,
            zIndex: isSticky ? 2 : "inherit"
          },
          isSticky && tableColumnRightDropShadow(scrollHorizontal)
        ])}
      >
        {/* companies hierarchy page cells should stay empty since values are rendered together with TableCheckbox*/}

        {companiesPage
          ? null
          : renderValue(name, resource, data, secondCellValue)}
      </TableCell>
    </LongTextTooltip>
  );
};

export default TableColumn;
